import { ref, Ref } from 'vue';
import { useForm } from 'Helpers/form';
import { FormModelLogin } from '../models/FormModelLogin';
import { useFormValidationLogin } from './useFormValidationLogin';

export function useFormLogin() {
  const formModel: Ref<FormModelLogin> = ref(new FormModelLogin());
  const formValidation = useFormValidationLogin(formModel);
  const formOptions = {
    formModel,
    formValidation,
    scrollTopOnSuccess: false,
  };

  const formHandler = useForm(formOptions);

  return {
    ...formHandler,
    formModel,
  };
}
